import { businessStatus } from './../../common/function';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import KeenSlider, { KeenSliderInstance, KeenSliderPlugin } from 'keen-slider';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subscription, zip } from 'rxjs';
import {
  Function,
  businessHours,
  tooltipTriggers,
} from 'src/app/common/function';
import { toInstagramUrl, toTelUrl, toTwitterUrl, toWebsiteUrl } from 'src/app/common/contact-links';
import { directionsUrl } from 'src/app/common/directions';
import { CropResult, GalleryImageModel } from 'src/app/models/gallery-image-model';
import { KeyNameModel, KeyTitleModel } from 'src/app/models/key-value-model';
import { Business, BusinessMenu } from 'src/app/models/register-business';
import { BusinessService } from 'src/app/services/business.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PageTitleService } from 'src/app/services/page-title.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrls: ['./business-detail.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class BusinessDetailComponent implements OnInit {
  model!: NgbDateStruct;
  subscription: Subscription;
  subscribeImages: Subscription;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  selectedProduct: BusinessMenu;
  selectedIndex: number | null = null;
  constructor(
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private businessService: BusinessService,
    private userService: UserService,
    private toastService: ToastrService,
    public loaderService: LoaderService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private deviceDetector: DeviceDetectorService,
    private pageTitle: PageTitleService
  ) {
    this.isMobile = deviceDetector.isMobile();
    this.isTablet = deviceDetector.isTablet();
    this.isDesktop = deviceDetector.isDesktop();
  }
  activeDishPanel = 1;
  active = 'top';
  activePhotoPanel = 0;
  isCaroselLoading = true;
  isStatic = false;
  isImageExpanded = false;
  activeCategoryPanel = 0;

  // Slider With Thumb Code
  @ViewChild('sliderRef') sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('thumbnailRef') thumbnailRef!: ElementRef<HTMLElement>;
  @ViewChild('sliderWithThumbWrap') sliderWithThumbWrap!: ElementRef<HTMLElement>;
  @ViewChildren('sliderRefInner') sliderRefsInner!: QueryList<
    ElementRef<HTMLElement>
  >;
  @ViewChild('GoogleMap') map: any;

  slider!: KeenSliderInstance;
  thumbnailSlider!: KeenSliderInstance;
  currentSlide: number = 0;
  businessDetails: Business = new Business();
  menuCategories: KeyTitleModel[] = [];
  photoCategories: KeyNameModel[] = [];
  galleryImages: GalleryImageModel[] = [];
  filteredGalleryImages: GalleryImageModel[] = [];
  // How many products each menu category holds; read by the tab badges every CD pass.
  productCountByCategory: Record<number, number> = {};
  images: GalleryImageModel[] = [];
  sliderInner!: KeenSliderInstance[];
  sliderCreated: boolean = false;
  products: BusinessMenu[] = [];
  filterProducts: any[] = [];

  formattedHours: string[] = [];
  staticFormattedHours: string = '';
  initialCoordinates = {
    lat: 23.0346735,
    lng: 72.4979519,
  };
  branchId: number;
  mapOptions: google.maps.MapOptions = {
    center: this.initialCoordinates,
    zoom: 15,
    mapTypeControl: false,
    zoomControl: false,
    streetViewControl: false,
    disableDefaultUI: true,
    mapId: '8f348c95f505df06'
  };
  markers: google.maps.marker.AdvancedMarkerElement[] = [];
  currentLocation: any;
  toolTipHours: any[] = [];
  // Resolved hrefs for the contact block; '' renders that row as plain "-" text
  // rather than a dead link (see contact-links.ts / directions.ts).
  contactLinks = { tel: '', website: '', instagram: '', twitter: '', directions: '' };
  hoursTooltipTriggers = tooltipTriggers();
  isSliderExist: boolean = false;
  reviewList: any[] = [];
  bannerImages = ['./assets/images/banner-1.webp', './assets/images/banner-2.webp', './assets/images/banner-3.webp']
  selectedImages: any[] = [];
  gallaryImageList: any[] = [];
  currentCategoryImageIndex: { [Key: string]: number } = {};
  activeCategory: string = 'Faced';
  thumbImageList: any[] = [];
  lastActiveCategory: string | null = null;

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.setDeviceType(event.target.innerWidth);
    if (this.isImageExpanded) {
      this.syncExpandedImageHeight();
    }
    setTimeout(() => {
      if (this.sliderInner) {
        this.sliderInner.forEach((ref) => {
          ref.update();
        });
      }
      // Width drives a landscape photo's height, so the track has to be re-measured
      // once the sliders have settled at the new width.
      this.syncExpandedTrackHeight();
    }, 200);
  }

  toggleImageExpand(event?: Event): void {
    event?.stopPropagation();
    this.isImageExpanded = !this.isImageExpanded;

    // Measuring has to wait for change detection to put `.is-image-expanded` on the
    // wrapper, because the thumbnail rail's margin — part of the budget — only flips
    // to its expanded value then. The CSS `calc(100dvh - …)` fallback covers this frame.
    setTimeout(() => {
      if (this.isImageExpanded) {
        this.syncExpandedImageHeight();
      }
      this.slider?.update();
      if (this.sliderInner?.length) {
        this.sliderInner.forEach((innerSlider) => innerSlider.update());
      }
      if (this.isImageExpanded) {
        // After the sliders have re-measured, so the photo has its final width and the
        // track height is taken from a settled layout.
        this.syncExpandedTrackHeight();
        this.scrollExpandedImageIntoView();
      }
    });
  }

  private setDeviceType(width: number): void {
    if (width <= 768) {
      this.isMobile = true;
      this.isTablet = false;
      this.isDesktop = false;
    } else if (width <= 1024) {
      this.isTablet = true;
      this.isMobile = false;
      this.isDesktop = false;
    } else {
      this.isDesktop = true;
      this.isMobile = false;
      this.isTablet = false;
    }
  }

  /**
   * Publishes the vertical budget an expanded photo may occupy. It is a CAP, not a
   * reservation: the CSS lets the box shrink to the photo, so a landscape shot on a
   * narrow screen no longer leaves several hundred pixels of empty white below it.
   *
   * Must run after change detection has applied `.is-image-expanded`, since the
   * thumbnail rail's own margin flips from -70px (overlapping the photo) to +8px
   * (sitting below it) and that margin is part of the budget.
   */
  private syncExpandedImageHeight(): void {
    const wrap = this.sliderWithThumbWrap?.nativeElement;
    if (!wrap) {
      return;
    }

    // visualViewport is the area genuinely on screen. window.innerHeight still counts the
    // strip behind a mobile browser's collapsing address bar, so it over-reports by ~60-100px
    // and pushed the thumbnail rail off the bottom of the screen.
    const viewportHeight = window.visualViewport?.height ?? window.innerHeight;
    const rail = this.thumbnailRef?.nativeElement?.closest('.thumb-wrap') as HTMLElement | null;
    const railSpace = rail
      ? rail.getBoundingClientRect().height + (parseFloat(getComputedStyle(rail).marginTop) || 0)
      : 0;
    const breathingRoom = this.isMobile ? 24 : 40;
    const available = Math.max(
      BusinessDetailComponent.MIN_EXPANDED_IMAGE_HEIGHT,
      viewportHeight - railSpace - breathingRoom
    );
    wrap.style.setProperty('--expanded-image-height', `${Math.round(available)}px`);
  }

  /** Never collapse the expanded view to nothing, however cramped the window. */
  private static readonly MIN_EXPANDED_IMAGE_HEIGHT = 320;

  /**
   * Sizes the carousel track to the photo actually on screen.
   *
   * A flex track is as tall as its TALLEST child, and the children here are every photo
   * in every category. One portrait shot was therefore giving every landscape shot in
   * every other category a box hundreds of pixels taller than itself. Only the visible
   * photo should decide the height.
   */
  private syncExpandedTrackHeight(): void {
    const wrap = this.sliderWithThumbWrap?.nativeElement;
    if (!wrap || !this.isImageExpanded) {
      return;
    }
    const category = wrap.querySelectorAll('.top-slider > .keen-slider__slide')[this.currentSlide];
    const innerIndex = this.sliderInner?.[this.currentSlide]?.track?.details?.rel ?? 0;
    const slide = category?.querySelectorAll('.inner-slider > .keen-slider__slide')[innerIndex];
    const height = slide?.querySelector('img')?.getBoundingClientRect().height;
    // 0 while a photo is still decoding; the load handler calls back in that case.
    if (height) {
      wrap.style.setProperty('--expanded-track-height', `${Math.round(height)}px`);
    }
  }

  /** Both budgets, in the order they depend on each other. */
  private syncExpandedLayout(): void {
    this.syncExpandedImageHeight();
    this.syncExpandedTrackHeight();
  }

  /** A photo has no measurable height until it decodes; re-measure once it does. */
  onExpandedImageLoad(): void {
    if (this.isImageExpanded) {
      this.syncExpandedTrackHeight();
    }
  }

  // A mobile browser collapsing or revealing its address bar changes the visible height
  // WITHOUT firing window:resize, so the budget would stay stale until the next rotation.
  private readonly onViewportResize = () => {
    if (this.isImageExpanded) {
      this.syncExpandedLayout();
    }
  };

  private watchViewportHeight(): void {
    window.visualViewport?.addEventListener('resize', this.onViewportResize);
  }

  private unwatchViewportHeight(): void {
    window.visualViewport?.removeEventListener('resize', this.onViewportResize);
  }

  private scrollExpandedImageIntoView(): void {
    this.sliderWithThumbWrap?.nativeElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }

  ngOnInit() {
    this.watchViewportHeight();
    this.route.params.subscribe((params) => {
      this.branchId = Number.parseInt(params['id']);
      this.businessService
        .getBusinessById(this.branchId)
        .subscribe((response: any) => {
          this.businessDetails = response;
          this.pageTitle.set(response?.name);
          this.contactLinks = {
            tel: toTelUrl(response?.phoneNumber),
            website: toWebsiteUrl(response?.website),
            instagram: toInstagramUrl(response?.instagram),
            twitter: toTwitterUrl(response?.twitter),
            directions: directionsUrl(response?.lat, response?.lng, response?.address),
          };

          // If lat/lng are available, update map center and add marker
          if (this.businessDetails.lat && this.businessDetails.lng) {
            this.initialCoordinates = {
              lat: this.businessDetails.lat,
              lng: this.businessDetails.lng
            };

            // Only update center and zoom, not the entire options
            if (this.map?.googleMap) {
              this.map.googleMap.setCenter(this.initialCoordinates);
              this.map.googleMap.setZoom(15);
            }

            // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
            setTimeout(() => {
              this.markLocation(this.businessDetails.lat, this.businessDetails.lng);
            });
          }
          this.businessDetails.status = this.businessDetails
            ?.membershipAppCompanyBusinessHourList
            ? businessStatus.isBusinessOpen(
              this.businessDetails.membershipAppCompanyBusinessHourList
            )
              ? 'open now'
              : 'closed now'
            : '';
          if (
            this.businessDetails.membershipAppCompanyBusinessHourList?.length
          ) {
            this.businessDetails.membershipAppCompanyBusinessHourList.forEach(
              (hour) => {
                if (hour.from != '' || hour.to != '') {
                  if (hour.from.length == 7) {
                    hour.from = '0' + hour.from;
                  }
                  if (hour.to.length == 7) {
                    hour.to = '0' + hour.to;
                  }
                }
              }
            );
            this.formattedHours = businessHours.groupBySameTiming(
              this.businessDetails.membershipAppCompanyBusinessHourList
            );
            this.businessDetails.membershipAppCompanyBusinessHourList.sort(
              (a, b) => a.day - b.day
            );
            const hours =
              this.businessDetails.membershipAppCompanyBusinessHourList;
            hours.forEach((hour) => {
              hour.day = businessHours.getDayName(hour.day);
              this.toolTipHours.push(hour);
            });
          }
          zip(
            this.userService.getAll(
              `api/getEnumList/MembershipBranchImageType`
            ),
            this.userService.getAll(
              `api/tenants/membershipApp/GetAllMembershipProductCategories?businessPartnerId=${this.businessDetails.businessPartnerId}`
            ),
            this.userService.getAll(
              `api/tenants/membershipApp/GetCompanyMenue?SubBranchId=${this.businessDetails.branchId}&SkipPaging=true`
            ),
            this.userService.getAll(
              `api/clients/getReviewNotes?isForReview=true&branchId=${this.businessDetails.branchId}&businessPartnerId=${this.businessDetails.businessPartnerId}`
            )
          ).subscribe(
            ([photoCategories, productCategories, products, reviews]: any[]) => {
              this.photoCategories = photoCategories.map((item) => ({
                id: item.value,
                name: item.enumName,
              }));

              this.menuCategories = Function.sortItems(
                productCategories.map((item) => ({
                  id: item.id,
                  title: item.title,
                }))
              );

              this.photoCategories.forEach((category) => {
                this.pushDataInGalleryImages(category);
                this.pushDataInImages(category);
              });

              this.products = products.records.map((product) => ({
                id: product.id,
                title: product.title,
                productCategoryId: product.productCategoryId,
                productImageUrl: product.image,
                price: product.price,
                description: product.description,
                productImageId: product.productImages[0]?.id,
              }));
              this.productCountByCategory = {};
              this.products.forEach((product) => {
                this.productCountByCategory[product.productCategoryId] =
                  (this.productCountByCategory[product.productCategoryId] || 0) + 1;
              });

              const categoryIdsWithProducts = new Set(this.products.map(p => p.productCategoryId));
              const categoriesWithProducts = this.menuCategories.filter(cat => categoryIdsWithProducts.has(cat.id));
              if (categoriesWithProducts.length > 0) {
                this.activeCategoryPanel = categoriesWithProducts[0].id;
                this.getProductsByCategoryId(this.activeCategoryPanel);
              }
              else {
                this.activeCategoryPanel = this.menuCategories[0].id;
                this.getProductsByCategoryId(this.activeCategoryPanel);
              }

              this.reviewList = reviews.records.map((review) => ({
                avatar: review.createdBy?.photo ? review.createdBy.photo : './assets/images/review-avatar-2.png',
                name: review.createdBy.title,
                date: review.createdOn,
                rating: review.rating,
                ratingIcon: './assets/images/ic-primary-rating.svg',
                ratedTime: this.getDaysAgoLabel(review.createdOn),
                reviewText: review.notes,
                numPhotos: review.crmNoteImages.length,
                reply: null,
                crmNoteImages: review.crmNoteImages,
                tagsList: review.tagsList
              }));

              this.loaderService.setLoading(false);
              this.userService
                .getCurrentLocation()
                .then((result) => {
                  this.currentLocation = {
                    city: result.city,
                    lat: result.lat,
                    lng: result.lng,
                  };
                })
                .catch((error) => {
                  console.error(error);
                });

              // Use setTimeout to avoid ExpressionChangedAfterItHasBeenCheckedError
              setTimeout(() => {
                if (!this.sliderCreated && this.filteredGalleryImages.length > 0) {
                  this.sliderFunction();
                }
              });
            }
          );
        });
    });
    this.selectedImages = this.getRandomImages(this.bannerImages, 2);
  }

  getRandomImages(array: string[], count: number): string[] {
    const shuffled = [...array].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }

  cropImage(imageSrc: string, x: number, y: number, width: number, height: number, widthRsp: number, heightRsp: number): Observable<string> {
    return new Observable(observer => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        return;
      }

      const img = new Image();
      if (imageSrc != null || imageSrc != undefined) {
        img.crossOrigin = "anonymous";
        img.src = imageSrc;

        img.onload = () => {
          canvas.width = widthRsp;
          canvas.height = heightRsp;

          ctx.drawImage(
            img,
            x, y,
            width, height,
            0, 0,
            widthRsp, heightRsp
          );

          const croppedData = canvas.toDataURL("image/png");
          observer.next(croppedData);
          observer.complete();
        }

        img.onerror = () => {
          img.src = imageSrc;
        }
      }
      else {
        img.src = imageSrc;
      }
    });
  }

  cropMobileImage(
    imageSrc: string,
    sx: number, sy: number,
    sw: number, sh: number,
    displayW: number, displayH: number
  ): Observable<CropResult> {
    return new Observable(observer => {
      const img = new Image();
      if (imageSrc != null || imageSrc != undefined) {
        img.crossOrigin = 'anonymous';
        img.src = imageSrc;

        img.onload = () => {
          const dpr = window.devicePixelRatio || 1;
          const pixelW = displayW * dpr;
          const pixelH = displayH * dpr;

          const canvas = document.createElement('canvas');
          canvas.width = pixelW;
          canvas.height = pixelH;
          canvas.style.width = `${displayW}px`;
          canvas.style.height = `${displayH}px`;

          const ctx = canvas.getContext('2d')!;
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.scale(dpr, dpr);

          // draw the cropped region at CSS size (will map to full-res bitmap)
          ctx.drawImage(
            img,
            sx, sy, sw, sh,      // source
            0, 0, displayW, displayH // destination
          );

          canvas.toBlob(blob => {
            if (blob) {
              observer.next({ blob, pixelW, pixelH });
              observer.complete();
            } else {
              observer.error('Failed to convert canvas to Blob');
            }
          }, 'image/png', 1);
        };

        img.onerror = () => observer.error('Image load error');
      } else {
        img.src = imageSrc;
      }
    });
  }


  sliderFunction() {
    if (!this.sliderRef?.nativeElement || !this.thumbnailRef?.nativeElement) {
      return;
    }

    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
          // Moving to another category means a different photo decides the height.
          this.syncExpandedTrackHeight();
        },
        rubberband: false,
        breakpoints: {
          '(max-width: 575px)': {
            slides: { spacing: 12 },
          },
        },
        selector: '.top-slider > .keen-slider__slide',
      },
      [
        (slider) => {
          slider.on('created', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === this.currentSlide) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
          slider.on('slideChanged', (s) => {
            const slideElements = s.slides;
            slideElements.forEach((slide, index) => {
              if (index === s.track.details.abs) {
                slide.classList.add('active');
              } else {
                slide.classList.remove('active');
              }
            });
          });
        },
      ]
    );

    this.thumbnailSlider = new KeenSlider(
      this.thumbnailRef.nativeElement,
      {
        initial: 0,
        slides: {
          perView: 4,
          spacing: 0,
        },
        breakpoints: {
          '(max-width: 575px)': {
            slides: { perView: 4, spacing: 8 },
          },
        },
      },
      [this.ThumbnailPlugin(this.slider)]
    );
    this.sliderInner = [];
    setTimeout(() => {
      this.sliderRefsInner.forEach((ref) => {
        this.sliderInner.push(
          new KeenSlider(ref.nativeElement, {
            rubberband: false,
            slides: {
              perView: 1,
            },
            // Paging within a category swaps to a photo of a different shape.
            slideChanged: () => this.syncExpandedTrackHeight(),
          })
        );
      });
      this.sliderCreated = true;
      this.isCaroselLoading = false;
    });
  }

  ngOnDestroy() {
    this.unwatchViewportHeight();
    if (this.slider) this.slider.destroy();
    if (this.thumbnailSlider) this.thumbnailSlider.destroy();
    if (this.sliderInner?.length) {
      for (var sliderInner of this.sliderInner) {
        sliderInner.destroy();
      }
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscribeImages) {
      this.subscribeImages.unsubscribe();
    }
  }

  ThumbnailPlugin(main: KeenSliderInstance): KeenSliderPlugin {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove('active');
        });
      }
      function addActive(idx: number) {
        slider.slides[idx].classList.add('active');
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener('click', () => {
            main.moveToIdx(idx);
          });
        });
      }

      slider.on('created', () => {
        if (slider.track.details) {
          addActive(slider.track.details.rel);
          addClickEvents();
          main.on('animationStarted', (main) => {
            removeActive();
            const next = main.animator.targetIdx || 0;
            addActive(main.track.absToRel(next));
            slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
          });
        }
      });
    };
  }

  checkNoRecord(categoryId: number) {
    return !this.productCountByCategory[categoryId];
  }

  trackByEntityId(index: number, item: any): number {
    return item?.id ?? index;
  }

  async markLocation(lat: number, lng: number) {
    if (!lat || !lng) return;

    this.initialCoordinates = {
      lat: lat,
      lng: lng,
    };

    // Clear existing markers
    this.markers.forEach((marker: any) => {
      if (marker.map) marker.map = null;
    });
    this.markers.length = 0;

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    // Create marker element with the same style as listing page
    const element = document.createElement('div');
    element.innerHTML = `
      <div style="position: relative; cursor: pointer;">
        <img src="./assets/images/location-listing-page.svg" style="width: 45px; height: 56px;"/>
        <div style="position: absolute; top: 35%; left: 50%; transform: translate(-50%, -50%); color: white; font-size: 12px; font-weight: 500; font-family: Barlow;">
          
        </div>
      </div>
    `;

    const marker = new AdvancedMarkerElement({
      map: this.map?.googleMap,
      position: this.initialCoordinates,
      content: element,
      title: this.businessDetails?.name || 'Location'
    });

    this.markers.push(marker);
  }

  highlight($event) {
    this.setMarkerHighlight($event, true);
  }

  removeHighlight($event) {
    this.setMarkerHighlight($event, false);
  }

  /**
   * Swaps the pin image on the existing marker content. The previous version
   * built a fresh innerHTML tree and replaced `marker.content` on every event —
   * and the header fired those events for every child the pointer crossed.
   * Idempotent, so repeated events while hovered cost one string compare.
   */
  private setMarkerHighlight($event: { lat?: number; lng?: number }, highlighted: boolean) {
    const hasCoords = $event?.lat != 0 && $event?.lat != undefined && $event?.lng != 0 && $event?.lng != undefined;
    const marker = hasCoords
      ? this.markers.find((m) => m.position.lat === $event.lat && m.position.lng === $event.lng)
      : this.markers[0];
    const img = (marker?.content as HTMLElement | undefined)?.querySelector?.('img');
    if (!img) return;
    const src = highlighted
      ? './assets/images/location-listing-page-3.svg'
      : './assets/images/location-listing-page.svg';
    if (img.getAttribute('src') !== src) {
      img.setAttribute('src', src);
    }
  }

  pushDataInGalleryImages = (category: KeyNameModel) => {
    const imageTypeRsp = this.isMobile ? 3 : 1;

    let images = this.businessDetails.membershipBusinessImagesList
      .filter((x) => x.imageType == category.id)
      .map((item) => ({
        src: item.imagePath
      }));

    images.forEach(item => {
      const imageConfigurationDetails = this.businessDetails?.membershipBusinessImagesList?.find(
        (x) => x.imageType == category.id && x.imagePath == item.src)?.memberShipImageConfigurationViews?.find((y) => y.imageType == imageTypeRsp);
      this.setCroppedGalleryImages(imageConfigurationDetails, category, item.src);
    });

    this.galleryImages.push({
      id: category.id,
      category: category.name,
      images: images
    });
    this.filteredGalleryImages = this.galleryImages.filter(
      (imageArray) => imageArray.images.length > 0
    );
    this.isSliderExist = this.filteredGalleryImages.length > 0;
  }

  setCroppedGalleryImages = (imageConfigurationDetails: any, category: KeyNameModel, image: string) => {
    if (imageConfigurationDetails) {
      let widthRsp = this.isMobile ? 382 : 1296;
      let heightRsp = this.isMobile ? 300 : 406;

      this.subscription = this.cropMobileImage(image, imageConfigurationDetails?.x, imageConfigurationDetails?.y,
        imageConfigurationDetails?.width, imageConfigurationDetails?.height, widthRsp, heightRsp)
        .subscribe({
          next: ({ blob, pixelW, pixelH }: CropResult) => {
            const url = URL.createObjectURL(blob);
            this.galleryImages.forEach((event) => {
              if (event.id == category.id && event.images.find(p => p.src == image)) {
                let img = event.images.find(p => p.src == image);
                img.croppedSrc = url;
                img.pixelW = pixelW;
                img.pixelH = pixelH;
              }
            });
          },
          error: (err) => console.log("failed")
        });
    }
  }

  pushDataInImages = (category: KeyNameModel) => {
    let images = this.businessDetails.membershipBusinessImagesList
      .filter((x) => x.imageType == category.id)
      .map((item) => ({
        src: item.imagePath
      }));

    images.forEach(item => {
      const imageConfigurationDetails = this.businessDetails?.membershipBusinessImagesList?.find(
        (x) => x.imageType == category.id && x.imagePath == item.src)?.memberShipImageConfigurationViews?.find((y) => y.imageType == 2);
      this.setCroppedImages(imageConfigurationDetails, category, item.src);
    });

    this.images.push({
      id: category.id,
      category: category.name,
      images: images
    });
  }

  setCroppedImages = (imageConfigurationDetails: any, category: KeyNameModel, image: string) => {
    if (imageConfigurationDetails) {
      this.subscribeImages = this.cropImage(image, imageConfigurationDetails?.x, imageConfigurationDetails?.y,
        imageConfigurationDetails?.width, imageConfigurationDetails?.height, window.innerWidth, window.innerHeight)
        .subscribe({
          next: (cropped: any) => {
            this.images.forEach((event) => {
              if (event.id == category.id && event.images.find(p => p.src == image)) {
                let img = event.images.find(p => p.src == image);
                img.croppedSrc = cropped;
              }
            });
          },
          error: (err) => console.log("failed")
        });
    }
  }

  getDaysAgoLabel(createdDateInput: string | Date): string {
    const createdDate = new Date(createdDateInput);
    const currentDate = new Date();

    createdDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    const diffTime = currentDate.getTime() - createdDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return 'Today';
    }
    else if (diffDays === 1) {
      return 'Yesterday';
    }
    else {
      return `${diffDays} days ago`
    }
  }

  selectProduct(product: BusinessMenu, index: number) {
    if (this.selectedProduct && this.selectedProduct.id == product.id) {
      this.selectedProduct = null;
      this.selectedIndex = null;
    } else {
      this.selectedProduct = product;
      this.selectedIndex = index;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement).closest('.dish-ul');
    if (!clickedInside) {
      this.selectedIndex = null;
      this.selectedProduct = null;
    }
  }

  getProductsByCategoryId(categoryId: number) {
    this.filterProducts = this.products.filter((product) => product.productCategoryId === categoryId)
      .map((product, i) => ({
        ...product,
        index: i + 1
      }));
  }

  public openWhatsApp = () => {
    const phoneNumber = environment.whatsAppInquiryNumber;
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  }
}
